import React from 'react';
import { Navigate } from 'react-router';

export const ProcessDetailsMessagesRedirect: React.FC = () => (
  <Navigate relative="path" replace to=".." />
);
